/**
 * Erkennt das Bildformat ausschliesslich anhand der Dateiendung der URL.
 * Es wird bewusst NICHT der MIME-Type/HTTP-Header ausgewertet, da pro Item
 * nur eine URL bzw. BaseUrl uebergeben wird.
 */

const RASTER_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'];

/**
 * Liefert die Dateiendung (lowercase, ohne Punkt) einer URL.
 * Query-String (?v=1) und Fragment (#x) werden vorher entfernt.
 * @param {string} url
 * @returns {string}
 */
export function getImageExtension(url) {
  if (!url) {
    return '';
  }
  const clean = String(url).split('?')[0].split('#')[0];
  const dot = clean.lastIndexOf('.');
  if (dot < 0) {
    return '';
  }
  return clean.slice(dot + 1).toLowerCase();
}

/**
 * @param {string} url
 * @returns {boolean} true, wenn die URL auf .svg endet
 */
export function isSvg(url) {
  return getImageExtension(url) === 'svg';
}

/**
 * @param {string} url
 * @returns {boolean} true fuer png/jpg/jpeg/gif/webp/bmp
 */
export function isRaster(url) {
  return RASTER_EXTENSIONS.indexOf(getImageExtension(url)) !== -1;
}



// WEBPACK FOOTER //
// ./src/helpers/ImageType.js